import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { AuthUser } from '@/modules/auth/models/AuthUser';

export class BaseInboxEventTracking extends BaseEventTracking {
  userId: number;
  userName: string;
  userRole: string;

  constructor(authUser: AuthUser) {
    super();
    this.userId = authUser.id;
    this.userName = authUser.name ?? '';
    this.userRole = authUser.estateAccount?.roleName;
  }
}
